var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('component-page', {
    attrs: {
      "title": "Expansion panel"
    },
    scopedSlots: _vm._u([{
      key: "basicUsage",
      fn: function fn() {
        return [_c('a-expansion-panel', {
          scopedSlots: _vm._u([{
            key: "caption",
            fn: function fn(_ref) {
              var contentVisible = _ref.contentVisible;
              return [_vm._v(" " + _vm._s(contentVisible ? 'Collapse' : 'Expand') + " content ")];
            }
          }])
        }, [_vm._v(" " + _vm._s(_vm.loremIpsum) + " ")])];
      },
      proxy: true
    }])
  }, [_c('component-usage-example', {
    attrs: {
      "caption": "Initially expanded"
    }
  }, [_c('a-expansion-panel', {
    attrs: {
      "initially-expanded": ""
    },
    scopedSlots: _vm._u([{
      key: "caption",
      fn: function fn() {
        return [_vm._v(" Toggle Content ")];
      },
      proxy: true
    }])
  }, [_vm._v(" " + _vm._s(_vm.loremIpsum) + " ")])], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Header block option"
    }
  }, [_c('a-expansion-panel', {
    staticClass: "header-block-option",
    attrs: {
      "header-block": ""
    },
    scopedSlots: _vm._u([{
      key: "caption",
      fn: function fn() {
        return [_vm._v(" Toggle Content ")];
      },
      proxy: true
    }])
  }, [_vm._v(" " + _vm._s(_vm.loremIpsum) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }